module.exports = __webpack_public_path__ + "static/img/about.6aaec8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/repair/about.png
// module id = EwXs
// module chunks = 4